import React from "react";
import "./App.scss";
import WholeConway from "./components/WholeConway";

function App() {
  return (
    <div className="App">
      <WholeConway />
    </div>
  );
}

export default App;
